import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exchangeMagicLoginToken } from "../../lib/authApi";
import "../pulse/pulse.css";
import "./auth.css";

type Status = "checking" | "invalid";

// Lands a one-time "login as user" link minted by an admin (e.g. to view
// what a specific user actually sees). The token is opaque - it is only
// ever handed to the server for exchange, never inspected or trusted here.
// Server-side validation (expiry, single-use, audit log) is the only thing
// that decides whether this succeeds.
const MagicLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<Status>("checking");

  useEffect(() => {
    const token = searchParams.get("token")?.trim();
    if (!token) {
      setStatus("invalid");
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await exchangeMagicLoginToken(token);
        if (!cancelled) navigate("/dashboard", { replace: true });
      } catch {
        if (!cancelled) setStatus("invalid");
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="pulse-onboarding-shell pulse-auth-shell">
      <div className="pulse-onboarding-chrome" />
      <main className="pulse-onboarding-center pulse-auth-center">
        <div className="pulse-onboarding-wordmark">
          <img src="/pulse-icon.png" alt="" aria-hidden="true" className="pulse-v2-brand-mark" />
          Pulse
        </div>
        {status === "checking" ? (
          <>
            <h1>Signing you in</h1>
            <p>Verifying your login link...</p>
          </>
        ) : (
          <>
            <h1>This login link is invalid or expired</h1>
            <p>Login links are single-use and expire quickly. Ask for a new one and try again.</p>
            <button type="button" className="pulse-onboarding-primary" onClick={() => navigate("/login", { replace: true })}>
              Go to sign in
            </button>
          </>
        )}
      </main>
    </section>
  );
};

export default MagicLoginPage;
